export default __webpack_public_path__ + "31d353daf64840110b3ddbfbfbb38fda.ttf";